export default "__VITE_ASSET__49ee0dd7__"